/** Single-page endpoints can contain historical revisions. Use the newest record. */
export function selectLatestComponent<T extends { id: number; lang?: string }>(
  data: T | T[] | null | undefined,
  lang?: string,
): T | null {
  const records = (Array.isArray(data) ? data : data ? [data] : []).filter(
    (record) => !lang || !record.lang || record.lang === lang,
  );
  return records.reduce<T | null>(
    (latest, record) => (!latest || record.id > latest.id ? record : latest),
    null,
  );
}
